var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 21.75,
    fill: "#000000",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_65_129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 24,
    height: 24,
    fill: "#FFFFFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_65_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.95 32C28.8667 32 26.8083 31.5458 24.775 30.6375C22.7417 29.7292 20.8917 28.4417 19.225 26.775C17.5583 25.1083 16.2708 23.2583 15.3625 21.225C14.4542 19.1917 14 17.1333 14 15.05C14 14.75 14.1 14.5 14.3 14.3C14.5 14.1 14.75 14 15.05 14H19.1C19.3333 14 19.5417 14.0792 19.725 14.2375C19.9083 14.3958 20.0167 14.5833 20.05 14.8L20.7 18.3C20.7333 18.5667 20.725 18.7917 20.675 18.975C20.625 19.1583 20.5333 19.3167 20.4 19.45L17.975 21.9C18.3083 22.5167 18.7042 23.1125 19.1625 23.6875C19.6208 24.2625 20.125 24.8167 20.675 25.35C21.1917 25.8667 21.7333 26.3458 22.3 26.7875C22.8667 27.2292 23.4667 27.6333 24.1 28L26.45 25.65C26.6 25.5 26.7958 25.3875 27.0375 25.3125C27.2792 25.2375 27.5167 25.2167 27.75 25.25L31.2 25.95C31.4333 26.0167 31.625 26.1375 31.775 26.3125C31.925 26.4875 32 26.6833 32 26.9V30.95C32 31.25 31.9 31.5 31.7 31.7C31.5 31.9 31.25 32 30.95 32Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.5462a4b89c3427ca6637b5ad062296cd.svg";
export { ForwardRef as ReactComponent };